import React from "react";
import { IconComponent } from "../../../icons/phosphor";

export const FeatureWithIcon = ({ icon: Icon, title }: { icon: IconComponent; title: string }) => (
  <div className="cw-flex cw-items-center cw-gap-1 cw-text-brand cw-heading-lg">
    <Icon size={20} />
    <span>{title}</span>
  </div>
);
